import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ module, action, children, fallback = '/' }) => {
    const { user } = useAuth();
    const toastShown = useRef(false);

    const checkAccess = (moduleName, actionName) => {
        if (user?.role?.name === 'Superadmin' || user?.role?.name === 'Admin') return true;
        if (!user?.role?.permissions) return false;
        const modulePermissions = user.role.permissions[moduleName];
        if (!modulePermissions) return false;
        // When a specific action is provided, check that action directly
        if (actionName) return modulePermissions[actionName] === true;
        // Otherwise check if any permission is enabled (calculated ui_visible)
        return ['view', 'add', 'change', 'delete'].some(a => modulePermissions[a] === true);
    };

    const canAccess = checkAccess(module, action);

    useEffect(() => {
        if (!canAccess && user && !toastShown.current) {
            toastShown.current = true;
            toast.error(`Access denied: You don't have permission to view ${module.replace('_', ' ')}`);
        }
    }, [canAccess, module, user?.email]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!canAccess) {
        return <Navigate to={fallback} replace />;
    }

    return children;
};

export default ProtectedRoute; 